import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { CustomPreloadingStrategy } from '../app/registered-user/core/custom-preloading-strategy';

const routes: Routes = [
  
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path: 'boardRegistration',
    loadChildren: () => import('./registration/boardRegistration/boardRegistration.module').then(m => m.BoardRegistrationModule)
  },
  {
    path: 'termsofuse',
    loadChildren: () => import('./registration/terms-of-use/terms-of-use.module').then(m => m.TermsofUseModule)
  },
  {
    path: 'legalpolicy',
    loadChildren: () => import('./registration/legacy-policy/legacy-policy.module').then(m => m.LegalPrivacyPolicyModule)
  },
  {
    path: 'findusers',
    loadChildren: () => import('./registration/find-users/find-users.module').then(m => m.FindUsersModule)
  },
  {
    path: 'deleteuser',
    loadChildren: () => import('./registration/delete-user/delete-user.module').then(m => m.DeleteUserModule)
  },
  {
    path: 'logout',
    loadChildren: () => import('./registration/user-logout/user-logout.module').then(m => m.UserLogoutModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./registration/frequently-asked-questions/frequently-asked-questions.module').then(m => m.FaqModule)
  },
  {
    path: '',
    loadChildren: () => import('./registered-user/registered-user.module').then(m => m.RegisteredUserModule),
    canActivate: [MsalGuard],
    data: { applyPreload: true }
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  providers: [CustomPreloadingStrategy],
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: CustomPreloadingStrategy })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
